// @flow
import { assign } from 'lodash';
import { connect } from 'react-redux';
import {
    deleteGetAndStoreDashboards,
    shareDashboard,
    getAndStoreDashboards,
    getAndStoreVersionFlags,
    patchGetAndStoreDashboards,
    updatePermissionsGetAndStoreUsers,
} from '../modules/actions';
import Dashboard from '../components/pages/Dashboard';

function mapStateToProps(state: State) {
    return {
        dashboardsExist: state.dashboards.length > 0,
        user: state.user,
        dashboards: state.dashboards,
        dashboardsError: state.dashboardsError,
        users: state.users,
        versionFlags: state.versionFlags,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onGetDashboards: (clientId) => dispatch(getAndStoreDashboards(clientId)),
        onDeleteDashboard: (dashboardId, clientId) => {
            dispatch(deleteGetAndStoreDashboards(dashboardId, clientId)).catch((err) =>
                console.error(err)
            );
            return Promise.resolve();
        },
        onPatchDashboard: (dashboardId, clientId, options) => {
            dispatch(patchGetAndStoreDashboards(dashboardId, clientId, options)).catch((err) =>
                console.error(err)
            );
            return Promise.resolve();
        },
        onShareDashboard: (dashboardId, messageDetails) => {
            dispatch(shareDashboard(dashboardId, messageDetails)).catch((err) =>
                console.error(err)
            );
            return Promise.resolve();
        },
        onSavePermissions: (clientId, dashboardId, permissions) => {
            dispatch(updatePermissionsGetAndStoreUsers(clientId, dashboardId, permissions));
            return Promise.resolve();
        },
        onGetVersionFlags: (clientId) => dispatch(getAndStoreVersionFlags(clientId)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./containers/DashboardContainer.jsx